import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";
import { MprcConfirmDialog } from "./MprcConfirmDialog";

interface IProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const MprcPrompt: React.FC<IProps> = (props) => {
    const { open, onCancel, onConfirm } = props;
    const { theme } = useMprcTheme();

    return (
        <MprcConfirmDialog
            message={theme.MprcPrompt.message}
            open={open}
            yesText={theme.MprcPrompt.yesText}
            noText={theme.MprcPrompt.noText}
            onClose={(confirm) => { if (confirm) onConfirm(); else onCancel(); }}
        />
    );
};
